module.exports = __webpack_public_path__ + "media/images/sports_icons/006-volleyball-62dc41bd3d7397ff6d9bea4201418f5c.png";